module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "login-body",
    class: {
      landing: _vm.welcome
    }
  }, [(_vm.welcome) ? _c('div', {
    staticClass: "login-landing"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "versions-wrapper"
  }, [_c('div', {
    staticClass: "version-outer"
  }, [_c('div', {
    staticClass: "version"
  }, [_c('i', {
    staticClass: "fa fa-walking logo-font"
  }), _vm._v(" "), _c('h1', [_vm._v("Uniom")]), _vm._v(" "), _c('h2', [_vm._v("Beléptető rendszer - v1")]), _vm._v(" "), _c('button', {
    staticClass: "button with-icon",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.welcome = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-in-alt"
  }), _vm._v("Tovább (Korábbi verzió)")])])]), _vm._v(" "), _c('div', {
    staticClass: "version-outer"
  }, [_c('div', {
    staticClass: "version"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "assets/img/shield-key.svg"
    }
  }), _vm._v(" "), _c('h1', [_vm._v("Uniom")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "button with-icon",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.redirect('https://beleptetoadmin.sze.hu')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-in-alt"
  }), _vm._v("Tovább (Új verzió)")])])])])])]) : _c('section', [(_vm.shibLogin && !_vm.shib_error) ? _c('div', {
    staticClass: "login-panel shib"
  }, [_c('iframe', {
    attrs: {
      "src": "https://belepteto.sze.hu/Shibboleth.sso/Login?target=https://belepteto.sze.hu/api/shib_login_redirect",
      "width": "800",
      "height": "653",
      "frameborder": "0"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "login-panel-foot"
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.shibLogin = false
      }
    }
  }, [_vm._v("Címtár nélküli bejelentkezés")])])]) : (_vm.shibLogin && _vm.shib_error) ? _c('div', {
    staticClass: "login-panel"
  }, [_c('iframe', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "src": _vm.shibLogoutUrl,
      "width": "0px",
      "height": "0px",
      "scrolling": "no"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "login-panel-background"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "login-panel-body"
  }, [_vm._m(2), _vm._v(" "), _c('h2', {
    staticStyle: {
      "padding-bottom": "40px"
    }
  }, [_vm._v(_vm._s(_vm.shib_error))]), _vm._v(" "), _c('button', {
    staticClass: "button with-icon",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.relogin
    }
  }, [_c('i', {
    staticClass: "fa fa-redo-alt"
  }), _vm._v("Szeretnék újra bejelentkezni")])])])]) : _c('div', {
    staticClass: "login-panel"
  }, [_c('div', {
    staticClass: "login-panel-background"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "login-panel-body"
  }, [_c('h2', [_vm._v("Bejelentkezés")]), _vm._v(" "), _c('form', [_c('inputbox', {
    attrs: {
      "id": "email",
      "label": "Email",
      "errors": _vm.errors,
      "name": "email"
    },
    on: {
      "keydownEnter": _vm.login
    },
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.$set(_vm.form, "email", $$v)
      },
      expression: "form.email"
    }
  }), _vm._v(" "), _c('passwordbox', {
    attrs: {
      "id": "password",
      "label": "Jelszó",
      "errors": _vm.errors,
      "name": "password"
    },
    on: {
      "keydownEnter": _vm.login
    },
    model: {
      value: (_vm.form.password),
      callback: function($$v) {
        _vm.$set(_vm.form, "password", $$v)
      },
      expression: "form.password"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-actions clearfix"
  }, [_c('button', {
    staticClass: "button with-icon",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.login
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-in-alt"
  }), _vm._v("Bejelentkezés")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "login-panel-foot"
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.shibLogin = true
      }
    }
  }, [_vm._v("Címtáras bejelentkezés")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "v2"
  }, [_vm._v("Beléptető rendszer - "), _c('span', [_vm._v("v2")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-panel-head"
  }, [_c('h1', [_c('i', {
    staticClass: "fa fa-walking"
  }), _c('h1', [_vm._v("BR"), _c('span', [_vm._v(" - Beléptető rendszer")])])]), _vm._v(" "), _c('p', [_vm._v("A Széchenyi István Egyetem beléptető menedzsment felülete.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('strong', [_vm._v("Hiba!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-panel-head"
  }, [_c('h1', [_c('i', {
    staticClass: "fa fa-walking"
  }), _c('h1', [_vm._v("BR"), _c('span', [_vm._v(" - Beléptető rendszer")])])]), _vm._v(" "), _c('p', [_vm._v("A Széchenyi István Egyetem beléptető menedzsment felülete.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e841f766"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/login.vue
// module id = 330
// module chunks = 0